<style lang="scss" scoped>
.card {
  .card-body {
    padding: 30px;

    >ul {
      margin: 0
    }
  }

  .card-header {
    >section {
      align-items: flex-end;
    }
  }
}
.component {
  border: 0;

  .card-body {
    border-bottom: 1px solid #e1e1e1;
    border-left: 1px solid #e1e1e1;
    border-right: 1px solid #e1e1e1;
    min-height: 50px;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    padding: 2em;
  }
}

</style>

<template>
  <main class="main card section--full-width" v-if="loaded">
    <header class="card-header flex-space_between">
      <h2>Importar dados</h2>

      <label v-if="$route.name === 'DoctorPatientsImportPreview'">
        <select v-model="selectedOffice" class="form-select">
          <option v-for="(office, $index) in doctorOffices" :value="$index" :key="'office'+$index">{{office.name}}</option>
        </select>
      </label>
    </header>

    <section class="card-body card component">
      <transition name="fade">
        <router-view
          :selectedOffice="doctorOffices[selectedOffice]"
          :origin.sync="origin"
          :fileId.sync="fileId"
          @origin="origin = $event"
          @uploaded="fileId = $event"
        />
      </transition>
    </section>
  </main>
</template>

<script>
export default {
  data () {
    return {
      fileId: null,
      selectedOffice: 0,
      loaded: false,
      doctorOffices: [],
      origin: {
        sourceSystem: null,
        sourceSystemCnpj: null
      }
    }
  },
  mounted () {
    this.fn_SHOW_PROGRESS()
    let url = this.fn_IS_DOCTOR() ? '/doctor' : `secretary/doctor/${this.$route.params.doctorId}`
    this.$http.get(url, this.$store.getters.getAuthHeader).then(
      (res) => {
        this.doctorOffices = res.data.doctor_offices
        this.loaded = true
        if (!this.fileId) {
          this.$router.replace({name: 'DoctorPatientsImportPreview'})
        }
        this.fn_HIDE_PROGRESS()
      }
    )
  }
}
</script>
